import axios from "axios";
import { message } from "antd";

export default function setToken(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const localToken = localStorage.getItem("token");
if (localToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localToken}`;
}

axios.defaults.baseURL = process.env.REACT_APP_API_PATH;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (JSON.stringify(error).includes(404)) {
        message.error("Aradığınız sayfa bulunamamaktadır.");
    }
    if (JSON.stringify(error).includes(500)) {
        message.error("Bir hata oluştu.")
    }
    if (JSON.stringify(error).includes(401)) {
        message.error("Yetkiniz bulunmamaktadır.")
    }
    if (JSON.stringify(error).includes(409)) {
        message.error("Aynı kullanıcıdan daha önceden kayıt yapılmıştır.")
    }
    return Promise.reject(error);
});